import { createContext, useContext, useEffect } from 'react';

// 1. Create Context
const SectionContext = createContext();

// 2. Create Provider component
export function SectionProvider({ children, sectionClass }) {
  // Effect to handle body class changes
  useEffect(() => {
    // Remove all existing section classes
    document.body.className = document.body.className.replace(
      /\bsection\d+-bg\b/g,
      ''
    );
    // Add new class
    if (sectionClass) {
        document.body.classList.add('animated');
      document.body.classList.add(sectionClass);
    }

    // Cleanup on unmount
    return () => {
      if (sectionClass) {
        document.body.classList.remove(sectionClass);
      }
    };
  }, [sectionClass]);

  return (
    <SectionContext.Provider value={sectionClass}>
      {children}
    </SectionContext.Provider>
  );
}

// 3. Custom hook for easy access
export function useSection() {
  return useContext(SectionContext);
}